import { sharePointInternalFileName, sharePointInternalTitleName } from "../src/taskpane/config/constants";

export const sanitizeSearchValue = (searchValue: string): string => {
    return searchValue?.replaceAll('"', "")?.replaceAll("%", "")?.replaceAll("*", "")?.trim()?.toLowerCase();
}

export const filterStrictSearchResults = (isSharePointList: boolean, searchResults: any[], searchValue: string) => {
  const sanitizedSearchValue: string = sanitizeSearchValue(searchValue);

  const filterPredicate = (resultItem: any) => {
    let valueToSearch: string;
    if (isSharePointList) {
      valueToSearch = resultItem[sharePointInternalTitleName];
    }
    else {
      valueToSearch = resultItem[sharePointInternalFileName]
      || resultItem["LinkFilename"]
      || resultItem["LinkTitle"]
      || resultItem[sharePointInternalTitleName];
    }

    if (valueToSearch) {
      return valueToSearch.toLowerCase().indexOf(sanitizedSearchValue) !== -1;
    }
    return true;
  }

  return searchResults?.filter(filterPredicate);
}

export const filterStrictDriveItemSearchResults = (searchResults: any[], searchValue: string) => {
  const sanitizedSearchValue: string = sanitizeSearchValue(searchValue);

  const filterPredicate = (resultItem: any) => {
    if (resultItem?.name) {
      return resultItem.name.toLowerCase().indexOf(sanitizedSearchValue) !== -1;
    }
    return true;
  }

  return searchResults?.filter(filterPredicate);
}